<template>
    <div class="risk-result">
        <!--   <div class="risk-head"></div> -->
        <div class="nodata" v-if="isShowNoData">
            暂无测评数据
        </div>
        <ul class="queue-main">
            <li v-for="(item, index) in riskList" :key="index" @click="redirect(item)">
                <p>
                    <span class="queue-text">{{ item.assessmentTypeStr }}</span>
                    <small class="queue-time" v-if="item.assessmentStatus == 1">测评结果已过期，请重新测评</small>
                </p>
                <span class="queue-btn" v-if="item.assessmentStatus == 0">{{ item.ratingLevelStr }}</span>
                <span class="queue-btn" v-if="item.assessmentStatus == 1">重新测评</span>
                <span class="queue-btn" v-if="item.assessmentStatus == 2">立即测评</span>
            </li>
        </ul>
    </div>
</template>
<script>
import { callHandler } from "@/utils/bridge.js";
import sensors from "sa-sdk-javascript";

export default {
    data() {
        return {
            isShowNoData: false,
            token: "",
            riskList: []
        };
    },
    beforeMount() {
        const urlParams = this.$queryUrl(location.href);
        // const { token = "1c136f7c60ff7ba244f7ef73feb450f1:1" } = urlParams; //测试数据
        const { token } = urlParams; //测试数据
        this.token = decodeURIComponent(token);
        this.getList()
            .then(res => {
                const { riskList } = res.data;
                this.riskList = riskList;
                if(!riskList || riskList.length === 0){
                    this.isShowNoData = true;
                }
            })
            .catch(e => {
                this.$toast(e);
            });
        callHandler("xhNaviGoBack", "nativeCloseWeb"); //关闭webview
    },
    mounted() {
        sensors.track("TMRiskQueue");
    },
    methods: {
        async getList() {
            return await this.$request({
                url: "/h5/risk/riskList.json",
                data: this.$qs.stringify({
                    token: this.token
                })
            });
        },
        redirect(item) {
            const status = item.assessmentStatus;
            if (status == 0) {
                //跳到结果页面
                this.$router.push({
                    name: "riskResult",
                    query: {
                        token: this.token,
                        ratingLevelStr: item.ratingLevelStr,
                        remark: item.remark,
                        assessmentType: item.assessmentType,
                        riskAssessmentTime: item.riskAssessmentTime
                    }
                });
            } else {
                //跳到测评题页面
                this.$router.push({
                    name: "riskAssessment",
                    query: {
                        token: this.token,
                        assessmentType: item.assessmentType,
                        type: "retry"
                    }
                });
            }
        }
    }
};
</script>
<style lang="less">
.risk-result {
    width: 100%;
    /*  .risk-head {
        width: 100%;
        height: 96px;
        background-image: linear-gradient(270deg, #2b2632 0%, #53505a 99%);
    } */
    .nodata {
        text-align: center;
        padding-top: 320px;
        font-size: 16px;
        background: url("../../../assets/images/normal/null_icon_data.png") no-repeat center 200px;
        background-size: 95px 95px;
        color: #666;
    }
    .queue-main {
        width: 100%;
        background: #fff;
        border-radius: 20px;
        box-sizing: border-box;
        padding: 20px 16px;
        /*  margin-top: 20px; */

        li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 0 4px 0 #d4be82;
            border-radius: 4px;
            padding: 22px 16px;
            background-image: linear-gradient(90deg, #bd9c60 0%, #e0cb99 100%);
            margin-bottom: 16px;
            &:last-child {
                margin-bottom: 0;
            }
            .queue-time {
                font-size: 12px;
                color: #f2e2b7;
                display: block;
            }
            .queue-text {
                font-size: 15px;
                color: #ffffff;
            }
            .queue-btn {
                background: #ffffff;
                box-shadow: 0 0 8px 0 rgba(231, 222, 207, 0.48);
                border-radius: 14px;
                border-radius: 14px;
                font-size: 14px;
                color: #c0a266;
                padding: 4px 12px;
            }
        }
    }
}
</style>
